module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/_united-nations-14c463f30b04cb81f2a0558baecb84b5.png";